import React, { Component } from 'react';
import '../sass/home.scss';




export class Winners extends Component {
    static displayName = Winners.name;

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            breadcrums: [],

        };
        this.state.breadcrums.push({ title: 'Home', url: '/' });
    }


    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        this.populateWinners();
    }

    handleScroll(event) {
        setTimeout(() => {
            var sticky = document.getElementById("header"),
                scroll = window.scrollY;
            if (scroll >= 50) sticky.classList.add('sticky');
            else sticky.classList.remove('sticky');
        }, 100);

    }

    async populateWinners() {
        const response = await fetch('v1/api/winners', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        if (data.status)
            this.setState({ data: data.data });


    }

    renderWinners(data: []) {
        var contests = [...new Set(data.map(c => c.title))];
        if (contests?.length > 0) {
            return contests?.map((item, idx) => {
                var winnersList = data.filter(c => c.title == item);
                return (
                    <>

                        <table class="table">
                            <tbody>
                                <tr>
                                    <th colspan="2">{item}</th>
                                </tr>
                                {this.renderUsers(winnersList)}

                            </tbody>
                        </table>
                    </>)
            })
        } else {

            return (<>
                <table class="table">
                    <tbody>
                        <tr>
                            <th colspan="2"></th>
                        </tr>                       
                        <tr>
                            <td>#</td>
                            <td>No Winner Data Avialable</td>
                        </tr>
                    </tbody>
                </table>
            </>);
        }
    }

    renderUsers(data: []) {
        return data?.map((item, idx) => {            
            return (
                <>
                    <tr>
                        <td>{idx+1}.</td>
                        <td>{item.firstname} {item.lastname}</td>
                    </tr>
                </>
            );
        });
    }
    render() {

        return (

            <>
                <section id="winners">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-12">
                                {this.renderWinners(this.state.data)}
                            </div>
                        </div>
                    </div>

                </section>

            </>
        );
    }
}
